import XIcon from "assets/icon/XIcon"

export default function BackButton(props){
    return(
        <button className="button flex gap-2 hover:shadow-lg hover:opacity-85 items-center" onClick={props?.onClick}>
            <XIcon className="w-5 fill-white" />
            <span>Back</span>
        </button>
    )
}